import Image, { type ImageProps } from 'next/image'

import { useImageVariant } from '@/@core/hooks/useImageVariant'

const loadingImageLight = '/images/loading-light.svg'
const loadingImageDark = '/images/loading-dark.svg'

type BamaImageProps = Omit<ImageProps, 'src'> & {
  src: ImageProps['src'] | null | undefined
}

const BamaImage = ({ src, ...rest }: BamaImageProps) => {
  const loadingImage = useImageVariant('light', loadingImageLight, loadingImageDark)

  return <Image src={src ?? loadingImage} {...rest} />
}

export default BamaImage
